import { validationMessages } from "./validationMessages";

export interface ValidationOptions {
    fieldName: string;
    required?: boolean;
    maxLength?: number | null;
    pattern?: RegExp | null;
}

export const validationPatterns = {
    alpha: /^[A-Za-z\s]+$/,
    alphaWithHyphen: /^[A-Za-z\s-]+$/,
    alphanumeric: /^[A-Za-z0-9]+$/,
    alphaWithSpecial: /^[A-Za-z0-9\s\-_]+$/,
    alphanumericWithHyphenSpace: /^[A-Za-z0-9\s-]+$/,
    alphanumericWithSpace: /^[A-Za-z0-9\s]+$/, 
    allowAll: /^[\s\S]*$/,
};

export const validateField = (value: any, options: ValidationOptions): string => {
    const {
        fieldName,
        required = false,
        maxLength = null,
        pattern = null,
    } = options;

    // ---------------------------------------
    // 1️⃣ Required validation (works for any type)
    // ---------------------------------------
   
    if (required) {
        const invalidDropdownValues = ["", "-1",-1, null, undefined];

        if (invalidDropdownValues.includes(value)) {
            return validationMessages.common_required(fieldName);
        }
    }
    // ---------------------------------------
    // 2️⃣ String validations only
    // ---------------------------------------
    if (typeof value === "string") {
        const trimmedValue = value.trim();

        // Max length validation
        if (maxLength !== null && trimmedValue.length > maxLength) {
            return validationMessages.common_characterLimit(fieldName, maxLength);
        }

        /// Automatic pattern detection
        if (pattern && !pattern.test(trimmedValue)) {
            // Find pattern name from validationPatterns
            const detectedPatternName = Object.keys(validationPatterns)
                .find(key => validationPatterns[key as keyof typeof validationPatterns] === pattern);

            const patternMessages: Record<string, string> = {
                alpha: `${fieldName} can contain only alphabets.`,
                alphaWithHyphen: `${fieldName} can contain only alphabets with space and hyphen.`,
                alphanumeric: `${fieldName} can contain only letters & numbers.`,
                alphaWithSpecial: `${fieldName} can contain only letters, numbers, spaces, hyphens, underscores.`,
                alphanumericWithHyphenSpace: `${fieldName} can contain only letters, numbers, spaces, and hyphens.`,
                alphanumericWithSpace: `${fieldName} can contain only letters, numbers and spaces.`,
            };

            if (detectedPatternName && patternMessages[detectedPatternName]) {
                return patternMessages[detectedPatternName];
            }

            return `${fieldName} format is invalid.`;
        }
    }

    return "";
};
